import { useEffect, useState } from "react";
import { api } from "../lib/api";

export function Version() {
	const [version, setVersion] = useState<string>("");

	useEffect(() => {
		const fetchVersion = async () => {
			try {
				const response = await api.get<{ version: string }>("/api/version");
				setVersion(response.data.version);
			} catch (error) {
				console.error("Error fetching version:", error);
				setVersion("unknown");
			}
		};

		fetchVersion();
	}, []);

	return <div className="text-xs text-gray-500">{version}</div>;
}
